const _relacionamento = {
    ALUNO: { Id: 1028, Descricao: "Aluno", Icone: "mdi-account-school-outline" },
    TECNICO_ADMINISTRATIVO: { Id: 1394, Descricao: "Técnico Administrativo", Icone: "mdi-account-hard-hat-outline" },
    PROFESSOR: { Id: 1304, Descricao: "Professor", Icone: "mdi-human-male-board-poll" },
}

export default _relacionamento
